export default "__VITE_ASSET__BUMP9RY4__"